import Axios from "axios";
import {
    GET_SOUSCRIPTION,
    setErrorMessage,
    setNewPasswordValue,
    setPasswordValue,
    setRedirection,
    setSouscription,
    setSuccessMessage,
    setVerifyPasswordValue,
    UPDATE_USER_INFOS
} from "../actions/user";
import {getApiBaseUrl} from "../utils/baseUrl";
import AuthService from "../common/auth.service";
import {setShowAccountModal} from "../actions/modal";
import {setErrorApiMessage} from "../actions/apiFlag";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const user = (store) => (next) => (action) => {
    switch (action.type) {
        // Action qui permet de mettre à jour les coordonnées du user via la modal Account
        case UPDATE_USER_INFOS : {
            const state = store.getState();
            const {user} = state;
            const url = `${getApiBaseUrl()}/updateUser/`;

            // @TODO: vérification du respect des caractères requis pour le nouveau mot de passe via la modal Account
            // En effet, les caractères du nouveau mot de passe n'est pas vérifié.
            // Il faut que tous les champs liés au password soient ou rempli, ou vide pour pouvoir envoyer la requête
            if (user.verifiedPassword && user.newPasswordValue && user.password) {
                const payload = {
                    "type": "adherent",
                    "email": user.dataUser.email,
                    "password": user.password,
                };
                AuthService.login(payload, {withCredentials: true}).then((res) => {
                    console.log(res);
                    if (res) {
                        const payload = {
                            "session": {
                                "id": window.localStorage.id,
                                "idUser": window.localStorage.idUser,
                                "email": window.localStorage.email,
                            },
                            "toUpdate": {
                                "password": user.verifiedPassword,
                                "email": user.dataUser.email,
                                "tel": user.dataUser.tel,
                                "cp": user.dataUser.cp,
                                "adress": user.dataUser.adress,
                                "city": user.dataUser.city,
                            }
                        };
                        // On envoie la requête seulement si les mots de passe correspondent
                        // Vérification de la concordance des passwords non effectuée côté back
                        if (user.verifiedPassword === user.newPasswordValue) {
                            Axios.post(url, payload)
                                .then((res) => {
                                    if (res) {
                                        // Si la requête est ok, on reset les inputs password, on ferme la modal et on affiche un message
                                        // de réussite
                                        store.dispatch(setPasswordValue(""));
                                        store.dispatch(setNewPasswordValue(""));
                                        store.dispatch(setVerifyPasswordValue(""));
                                        store.dispatch(setShowAccountModal(false));
                                        store.dispatch(setSuccessMessage("Vos informations ont bien été mis à jour"));
                                        setTimeout(() => {
                                            store.dispatch(setSuccessMessage(""));
                                        }, 3000);
                                    }
                                })
                                .catch((err) => {
                                    if (err.response.status === 401) {
                                        store.dispatch(setRedirection(true));
                                    }
                                    if (err) {
                                        if (err.code === "ECONNABORTED") {
                                            store.dispatch(setErrorApiMessage(true));
                                        }
                                        setTimeout(() => {
                                            store.dispatch(setErrorApiMessage(false));
                                        }, 5000);
                                    }
                                });

                        } else {
                            // Si les passwords ne sont pas identiques, on affiche un message d'errur
                            store.dispatch(setShowAccountModal(false));
                            store.dispatch(setErrorMessage("Les mots de passe ne sont pas identiques"));
                            store.dispatch(setPasswordValue(""));
                            store.dispatch(setNewPasswordValue(""));
                            store.dispatch(setVerifyPasswordValue(""));
                            setTimeout(() => {
                                store.dispatch(setErrorMessage(""));
                            }, 3000);
                        }
                    } else {
                        // Si le password actuel n'est pas le bon, on affiche un message d'erreur correspondant
                        store.dispatch(setShowAccountModal(false));
                        store.dispatch(setErrorMessage("Le mot de passe actuel est incorrect"));
                        store.dispatch(setPasswordValue(""));
                        store.dispatch(setNewPasswordValue(""));
                        store.dispatch(setVerifyPasswordValue(""));
                        setTimeout(() => {
                            store.dispatch(setErrorMessage(""));
                        }, 5000);
                    }
                });
            } else {
                // Si les inputs password de la modal sont vide, on update les autres champs que le user aura remplis
                const payload = {
                    "session": {
                        "id": window.localStorage.id,
                        "idUser": window.localStorage.idUser,
                        "email": window.localStorage.email,
                    },
                    "toUpdate": {
                        "email": user.dataUser.email,
                        "tel": user.dataUser.tel,
                        "cp": user.dataUser.cp,
                        "adress": user.dataUser.adress,
                        "city": user.dataUser.city,
                    }
                };

                Axios.post(url, payload)
                    .then((res) => {
                        if (res) {
                            store.dispatch(setShowAccountModal(false));
                            store.dispatch(setSuccessMessage("Vos informations ont bien été mis à jour"));
                            setTimeout(() => {
                                store.dispatch(setSuccessMessage(""));
                            }, 5000);
                            store.dispatch(setPasswordValue(""));
                            store.dispatch(setNewPasswordValue(""));
                            store.dispatch(setVerifyPasswordValue(""));
                        }
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            store.dispatch(setRedirection(true));
                        }
                        if (err) {
                            if (err.code === "ECONNABORTED") {
                                store.dispatch(setErrorApiMessage(true));
                            }
                            setTimeout(() => {
                                store.dispatch(setErrorApiMessage(false));
                            }, 5000);
                        }
                    });

            }
            next(action);
            break;
        }
        // Action permettant de récupérer les informations de souscriptions et de déterminer s'il en existe ou non
        case GET_SOUSCRIPTION : {
            const url = `${getApiBaseUrl()}/getSouscriptions/`;
            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
            };
            Axios.post(url, payload)
                .then((res) => {
                    if (res) {
                        // Destructuring du state
                        const state = store.getState();
                        const {user} = state;

                        const listSouscritptions = res.data.listSouscriptions;
                        // Si le user est un client B2C
                        if (user.dataUser.idExt === "B2C") {
                            if (!listSouscritptions) {
                                // S'il n'y a pas de souscriptions dans la liste récupérer, cela signifie que le client n'a pas
                                // encore souscrit d'offre ou est un client découlant du B2B
                                store.dispatch(setSouscription(false));
                            }
                            if (listSouscritptions) {
                                // Si la liste des souscriptions n'est pas vide, on regarde la colone "active"
                                listSouscritptions.find((sub) => {
                                    // Si active est sur 1 cela veut dire que le user à souscrit une offre
                                    if (sub.active == 1) {
                                        store.dispatch(setSouscription(true));
                                    } else {
                                        // Sinon, le user n'a pas encore souscrit d'offre
                                        store.dispatch(setSouscription(false));
                                    }
                                });
                            }
                        } else {
                            // Si l'idExt du user est différent de B2C, c'est qu'il est rattaché à une entreprise et n'a dont pas besoin
                            // de souscrire à un offre pour bénéficier du service
                            store.dispatch(setSouscription(true));
                        }
                    }
                });
            next(action);
            break;
        }
        // case GET_SOCIETE : {
        //     console.log("2 getSociete in user");
        //     const state = store.getState();
        //     const {user} = state;
        //     console.log("3 state.user in middlewareuser", state.user);
        //     // console.log("state.user.societe in middlewareuser", user.societe);
        //     const url = `${getApiBaseUrl()}/checkSociete/`;
        //
        //     const token = window.localStorage.getItem("id");
        //     const idUser = window.localStorage.getItem("idUser");
        //     const email = window.localStorage.getItem("email");
        //
        //     const payload = {
        //         "session": {
        //             "id": token,
        //             "email": email,
        //             "idUser": idUser
        //         },
        //         "idSociete": user.dataUser.idSociete
        //     };
        //     console.log("4 payload in middlewareuser", payload);
        //     Axios.post(url, payload, {withCredentials: true})
        //         .then((res) => {
        //             console.log("res in middlewareuser", res);
        //             console.log("res in middlewareuser", {
        //                 id: user.societe.id,
        //                 title: res.data.title,
        //                 text: res.data.text,
        //                 button: res.data.button
        //             });
        //             // store.dispatch(setSociete(
        //             //     {
        //             //         id: user.societe.id,
        //             //         title: res.data.title,
        //             //         text: res.data.text,
        //             //         button: res.data.button
        //             //     }
        //             // ));
        //         })
        //
        //         .catch((err) => {
        //             console.log("4", err);
        //         });
        // }
        //     next(action);
        // break;
        default:
            next(action);
    }
};

export default user;